import { render, staticRenderFns } from "./vaccination.vue?vue&type=template&id=0286c8a1&scoped=true&"
import script from "./vaccination.vue?vue&type=script&lang=js&"
export * from "./vaccination.vue?vue&type=script&lang=js&"
import style0 from "./vaccination.vue?vue&type=style&index=0&id=0286c8a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286c8a1",
  null
  
)

export default component.exports